import React from "react";
import DocumentViewer from "../components/DocumentViewer";
import { useMarkdownContent } from "../hooks/useMarkdownContent";

const ServiceLevelAgreementPage: React.FC = () => {
  const { content, loading, error } = useMarkdownContent(
    "service-level-agreement.md"
  );

  if (loading) {
    return (
      <div className="max-w-4xl mx-auto p-6">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500 mx-auto"></div>
          <p className="mt-2 text-gray-600">
            Loading Service Level Agreement...
          </p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-4xl mx-auto p-6">
        <div className="text-center text-red-600">
          <p>Error loading Service Level Agreement: {error}</p>
        </div>
      </div>
    );
  }

  return (
    <DocumentViewer
      content={content}
      title="Service Level Agreement"
      filename="baakas-service-level-agreement"
    />
  );
};

export default ServiceLevelAgreementPage;
